export default __webpack_public_path__ + "static/media/headphones.c263a42a.png";